import { fetchJson } from '~/utils/fetch-json-v2';
import type {
  ApiKey,
  CreateApiKeyPayload,
  CreateApiKeyResponse,
} from './types';

export async function getApiKeys(): Promise<ApiKey[]> {
  const { data, error } = await fetchJson<ApiKey[]>('/api-keys', {
    method: 'GET',
  });
  if (error) throw new Error(error);
  return data || [];
}

export async function createApiKey(
  payload: CreateApiKeyPayload,
): Promise<CreateApiKeyResponse> {
  const { data, error, status } = await fetchJson<CreateApiKeyResponse>(
    '/api-keys',
    {
      method: 'POST',
      body: payload,
    },
  );

  if (error) {
    if (status === 403) throw new Error('E_SCOPE_ESCALATION');
    if (status === 429) throw new Error('E_RATE_LIMIT');
    throw new Error(error);
  }

  const key_id = data?.key_id;
  const secret_key = data?.secret_key;
  const publishable_key = data?.publishable_key;

  if (!key_id || !secret_key) {
    throw new Error('Invalid response: missing key_id or secret_key');
  }

  return { key_id, secret_key, publishable_key: publishable_key || '' };
}

export async function revokeApiKey(id: string): Promise<void> {
  const { error } = await fetchJson(`/api-keys/${id}`, {
    method: 'DELETE',
  });
  if (error) throw new Error(error);
}

export async function rotateApiKey(
  id: string,
): Promise<{ secret_key: string }> {
  const { data, error } = await fetchJson<{ secret_key: string }>(
    `/api-keys/${id}/rotate`,
    { method: 'POST' },
  );
  if (error) throw new Error(error);
  if (!data?.secret_key) throw new Error('Invalid rotate response');
  return { secret_key: data.secret_key };
}
